import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const BouncyChunksAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const count = 15;
  const t = timeSeconds;
  for (let i = 0; i < count; i++) {
    const ang = (i / count) * Math.PI * 2;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const bx = Math.cos(ang) * r;
    const by = Math.sin(ang) * r;
    const vx = Math.cos(ang) * 200 * t;
    let vy = Math.sin(ang) * 100 * t + 1200 * t * t;
    const bounceFloor = config.containerRadius + 100;
    if (vy > bounceFloor) vy = bounceFloor - (vy - bounceFloor) * 0.4;
    const px = clampX(e.pos.x + bx + vx);
    const py = clampY(e.pos.y + by + vy);
    ctx.fillRect(px, py, 10 * (1 - progress), 10 * (1 - progress));
  }
};

registerBlastAnimation('BOUNCY_CHUNKS', BouncyChunksAnimation);
